import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';

import withStyles from '@material-ui/core/styles/withStyles';
import styles from 'assets/jss/material-dashboard-pro-react/components/dialogStyle';

class WithFormDialog extends Component {
	state = {
		isSubmitDisabled: true,
		showAnim: true,
		innerFormState: null,
		isSubmitTried: false,
	};

	componentDidMount() {
		const { disabled = true } = this.props;
		this.setState({
			isSubmitDisabled: disabled,
		});
	}

	onConfirm = () => {
		const { onConfirm, } = this.props;
		const { innerFormState, } = this.state;
		this.setState({
			isSubmitDisabled: true,
			showAnim: false,
			isSubmitTried: true,
		}, () => onConfirm(innerFormState));
	};

	render() {
		const { isSubmitDisabled, innerFormState, isSubmitTried, } = this.state;
		const {
			classes,
			title,
			children,
			onCancel,
			confirmBtnText,
			cancelBtnText,
			showIcon,
		} = this.props;

		const setStateFromChild = (state) => {
			this.setState({
				...state,
			});
		};

		return (
			<div>
				<SweetAlert
					warning={showIcon}
					title={title}
					onConfirm={this.onConfirm}
					onCancel={onCancel}
					confirmBtnCssClass={`${classes.button} ${classes.dialogButton} ${classes.dialogConfirmButton} ${classes.success}`}
					cancelBtnCssClass={`${classes.button} ${classes.dialogButton} ${classes.gray}`}
					confirmBtnText={confirmBtnText}
					cancelBtnText={cancelBtnText}
					closeOnClickOutside={false}
					showCancel
					openAnim={this.state.showAnim}
					disabled={isSubmitDisabled}
				>
					{(renderProps) => (
						Children.map(children, (child) => {
							return cloneElement(child, { innerFormState, setStateFromChild, renderProps, isSubmitTried, });
						})
					)}
				</SweetAlert>
			</div>
		);
	}
}

export default withStyles(styles)(WithFormDialog);

WithFormDialog.propTypes = {
	title: PropTypes.string.isRequired,
	children: PropTypes.any,
	onConfirm: PropTypes.func,
	onCancel: PropTypes.func,
	confirmBtnText: PropTypes.string,
	cancelBtnText: PropTypes.string,
	showIcon: PropTypes.bool,
};
